import { GenericAbortSignal } from 'axios';

import http from 'services/http';

// A chat channel on an inbound referral: one conversation per facility the referral was
// sent to. `audience` is the facility group ('Group' in v1). `unreadCount` is unread
// scaffolding — always 0 until the messages story (OLIO-2833+); the tab badge derives
// from it later. The list is policy-scoped server-side, so it contains only channels the
// user is allowed to see.
export interface ChatConversation {
  id: string;
  audience: { id: string; name: string; type: string };
  unreadCount: number;
}

// Colocated query keys (the repo's `*QueryKeys` convention, mirroring workflowQueryKeys).
export const chatQueryKeys = {
  base: ['chatConversations'] as const,
  index: (workflowId: string) => ['chatConversations', 'index', workflowId] as const,
};

// Bare top-level resource keyed by a (chattableType, chattableId) pivot, mirroring the
// attachments endpoint. OliveBranch snake-cases the query params server-side.
export async function getChatConversations(
  workflowId: string,
  signal?: GenericAbortSignal
): Promise<ChatConversation[]> {
  return http
    .get<{ data: ChatConversation[] }>('/chat_conversations', {
      params: { chattableType: 'Workflow', chattableId: workflowId },
      signal,
    })
    .then((res) => res.data.data);
}
